import { Box, Flex } from "@chakra-ui/react";
import React, { Fragment } from "react";
import Seo from "./seo";
import GameTypeSelector from "../../components/GameComponents/GameTypeSelector/GameTypeSelector";
import GameSelector from "../../components/GameComponents/GameSelector/GameSelector";
import PlatformSelectorRight from "../../components/GameComponents/PlatformSelector/PlatformSelector_right";
import useCheckLogin from "../../hook/useCheckLogin";
import MarqueeList from "../../components/marquee/marqueeList";
import JackpotList from "../JackpotList/JackpotList";
import useDeviceType from "../../hook/useDeviceType";

const Sports = ({ gameMainTypeFromProps }) => {
  const { isMachineUser, isMachineDomain } = useCheckLogin();
  const isMobile = useDeviceType() === "Mobile";
  const isTablet = useDeviceType() === "Tablet";
  return (
    <Fragment>
      <Seo />
      <Box
        as="section"
        px="common-y"
        position="sticky"
        top={"70px"}
        zIndex={1}
        bgColor="rgba(0,0,0,0.3)"
        display={{ base: "block", xl: "none" }}
        display={{ base: "block", xl: "none" }}
      >
        <GameTypeSelector ltr />
      </Box>

      <Box flex={1}>
        <Box
          display={{
            base: "none",
            md: "block",
          }}
          position="relative"
          zIndex={1000}
          w={{
            base: "100%",
          }}
          mt="15px"
        >
          {isMachineUser || isMachineDomain ? (
            <Flex direction={"column"} gap="10px" alignItems={"center"}>
              <Box w="100%">
                <MarqueeList />
              </Box>
              <Box w="100%">
                <PlatformSelectorRight
                  gameMainTypeFromProps={gameMainTypeFromProps}
                />
              </Box>
            </Flex>
          ) : (
            <MarqueeList />
          )}
        </Box>{" "}
        <Flex
          gap={{
            base: "0",
            md: "10px",
          }}
          py={{
            base: "0",
            md: "home-space",
          }}
          px="common-y"
          mb={{
            base: "60px",
            sm: "0px",
          }}
          w={{
            base: "100%",
          }}
          flexDirection={{
            base: "column-reverse",
            md: "row",
          }}
        >
          <Box
            py="home-space"
            px="common-y"
            mb={{
              base: "60px",
              sm: "0px",
            }}
            w={{
              base: "100%",
            }}
          >
            <GameSelector
              hiddenTitle
              isGridXLayout={isMachineUser || isMachineDomain}
              gameMainTypeFromProps={gameMainTypeFromProps}
              topLayout={!isMobile && !isTablet}
            />
          </Box>
          {isMachineUser || isMachineDomain ? null : (
            <Box>
              <PlatformSelectorRight
                direction={isMobile ? false : "col"}
                gameMainTypeFromProps={gameMainTypeFromProps}
              />
            </Box>
          )}{" "}
        </Flex>
        {/* <JackpotList fixed /> */}
      </Box>
    </Fragment>
  );
};

export default Sports;
